import { StrictMode } from 'react'
import { createRoot, hydrateRoot } from 'react-dom/client'
import { HelmetProvider } from '@saas-pages/shared/public/seo'
import { initMetrika } from '@saas-pages/shared/public/runtime'
import branding from '../branding.config'
import { App } from './app/App'
import './styles/index.css'

initMetrika(branding.metrikaId)

const rootElement = document.getElementById('root')
if (!rootElement) {
  throw new Error('Root element #root not found in the document.')
}

const app = (
  <StrictMode>
    <HelmetProvider>
      <App />
    </HelmetProvider>
  </StrictMode>
)

if (rootElement.hasChildNodes()) {
  hydrateRoot(rootElement, app)
} else {
  createRoot(rootElement).render(app)
}
